/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";

// errors
import ERRORS from "orchestration/firebase-library/errors/Errors.js";

// utils
import LoggerUtils from "utils/logger-utils/LoggerUtils.js";

class FirebaseStorage {
  static app = null;

  static getBucket() {
    return new Promise((resolve, reject) => {
      try { resolve(getStorage(FirebaseStorage.app)); }
      catch(error) { reject(error); }
    });
  }

  static async getDownloadUrl(storagePath) {
    const bucket = await FirebaseStorage.getBucket();
    const storageRef = ref(bucket, storagePath);
    return getDownloadURL(storageRef);
  }

  static upload(fileName, filePath, payload, metadata, onProgress) {
    return new Promise ((resolve, reject) => {
      const handleError = (error) => {
        LoggerUtils.error(error);
        reject(ERRORS.storageConnectionUnavailable);
      };

      const handleProgress = (progress) => {
        if(onProgress instanceof Function) {
          onProgress(progress);
        }
      };

      FirebaseStorage.getBucket()
      .then((bucket) => {
        const storageRef = ref(bucket, `${filePath}/${fileName}`);
        const uploadTask = uploadBytesResumable(
          storageRef,
          payload,
          { ...metadata, customMetadata: { ...metadata }}
        );
        uploadTask.on(
          "state_changed",
          (snapshot) => handleProgress(snapshot.bytesTransferred / snapshot.totalBytes),
          (error) => handleError(error),
          () => resolve(`${filePath}/${fileName}`)
        );
      })
      .catch((error) => handleError(error));
    });
  }
}
export default FirebaseStorage;
